import { DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, IColumn, Icon, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowProps, IRenderFunction, Link, MessageBarType, ProgressIndicator, SelectionMode, Stack, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { AttendeeRegistrationGridList } from '../../Events/Events/AttendeeRegistrationList/AttendeeRegistrationGridList';
import * as Services from '../../../../Services/Services';
import { IEventApi } from '../../../../Services/API/Event/IEventApi';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { EventPriceTypeEnum } from '../../../../Models/Event/EventPriceTypeEnum';
import EventProperties from '../../Events/Events/EventProperties/EventProperties';
import { IEvent } from '../../../../Models/Event/IEvent';

interface IUserRegistrationProps {
    userId: string;
    profile: IUserProfile;
}


export const UserAttendeeRegistration: React.FunctionComponent<IUserRegistrationProps> = (props) => {
    const [attendeeRegistrationList, setAttendeeRegistrationList] = React.useState<IEventItem[]>([]);
    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [selectedEvent, setSelectedEvent] = React.useState<IEvent>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);

    const theme = useTheme();

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    const buildColumns = () => {
        const _columns: IColumn[] = [
            { key: 'id', isCollapsible: true, name: 'Id', fieldName: 'id', minWidth: 80, maxWidth: 80, isResizable: true, styles: headerStyle },
            { key: 'name', name: 'Název', fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
            { key: 'schoolYear', isCollapsible: true, name: 'Školní rok', fieldName: 'schoolYear', minWidth: 60, maxWidth: 90, isResizable: true, styles: headerStyle },
            { key: 'ageGroupName', isCollapsible: true, name: 'Věková skupina', fieldName: 'ageGroupName', minWidth: 80, maxWidth: 150, isResizable: true, styles: headerStyle },
            { key: 'deleteButton', name: "delete", minWidth: 50, isIconOnly: true },
        ];
        setColumns(_columns);
    }
    React.useEffect(() => {
        buildColumns();

    }, []);

    React.useEffect(() => {
        if (props.userId) {
            loadData();
        }
    }, [props.userId]);

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventAttendee = await eventApi.getEventRegistredByUserAdmin(props.userId);

        if (eventAttendee.isSuccess && eventAttendee.data) {
            setAttendeeRegistrationList(eventAttendee.data);
        }
        else {
            setStatusMessage({ message: eventAttendee.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }

    const loadEvent = async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.getEvent(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setSelectedEvent(result.data);
            setIsPropertiesOpened.setTrue();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const renderPrice = (item: IEventItem) => {
        return (<>
            {item && item.priceType === EventPriceTypeEnum.ByEvent ?
                <span>{item.price},- Kč</span>
                : null}
            {item && item.priceType === EventPriceTypeEnum.BySemester ?
                <div>

                    {item.firstSemesterPrice == item.secondSemesterPrice ?
                        <span>Pololetí: {item.firstSemesterPrice},- Kč</span>
                        :
                        <Stack horizontalAlign="end" tokens={{ childrenGap: 0 }}>
                            <span>První pololetí: {item.firstSemesterPrice},- Kč</span>
                            <span>Druhé pololetí: {item.secondSemesterPrice},- Kč</span>
                        </Stack>
                    }
                </div>
                : null}

        </>)
    }

    const renderItemColumn = (item: IEventItem, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IEventItem];
            switch (column.key) {
                case 'id':
                    return <Link onClick={() => loadEvent(item.id)}>{fieldContent}</Link>
                case 'price':
                    return <Stack horizontalAlign="end" styles={{ root: { paddingLeft: 15 } }}>{renderPrice(item)}</Stack>;
                case 'isCamp':
                    return item.isCamp ? <Stack horizontalAlign="start" styles={{ root: { paddingLeft: 15 } }}><Icon title="Tábor" styles={{ root: { fontSize: 16 } }} iconName="Street" /></Stack> : null;
                default:
                    return <span style={{
                        height: '100%', display: 'flex', fontSize: 14,
                        alignItems: 'center'
                    }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    return (
        <Stack><Stack styles={{ root: { height: 10 } }}>
            {isLoading ? <ProgressIndicator /> : null}
        </Stack>
            <DetailsList
                items={attendeeRegistrationList}
                columns={columns}
                setKey="set"
                onRenderDetailsHeader={onRenderDetailsHeader}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
                onRenderItemColumn={renderItemColumn}
                
                selectionPreservedOnEmptyClick={false}
                ariaLabelForSelectionColumn="Výběr věkové skupiny"
                ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
                checkButtonAriaLabel="Vyber řádek"                
            />


            {selectedEvent ?
                <EventProperties item={selectedEvent}
                    isOpen={isPropertiesOpened}
                    close={setIsPropertiesOpened.setFalse}
                    refresh={() => { loadData() }}
                /> : null}
        </Stack>)
}


